module.exports = __webpack_public_path__ + "static/img/7.fce67d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/7.png
// module id = WB2Q
// module chunks = 0